import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import Anchor from '../shared/anchor';

import ConnectedModal from '../modal/modal';
import Button from '@mui/material/Button';

import { ReactComponent as Sun } from '../../images/sun.svg';
import Actions from '../../actions/actions';

const ModalStack = () => {
  const modalRequest = useSelector((state) => state.modalRequests);

  const [modals, setModals] = useState([]);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (modalRequest) {
      if (modalRequest?.modalAction === 'close') {
        setModals(modals.filter((m) => m.modalID !== modalRequest.modalID));
      } else {
        setModals(modals.concat([modalRequest]));
      }
      Actions.clearModalRequests();
    }
  }, [modalRequest, modals]);

  const now = new Date().getTime();
  const renderModal = (dialog, i) => {
    const {
      fullScreen,
      title,
      cancelButtonText = 'cancel',
      okButtonText = 'continue',
      okProcess = () => {},
      cancelProcess = () => {},
      contents,
      okClass = 'action-primary confirm-cancel action-info qa-generic-modal-confirm',
      modalClass = '',
      modalID = `qa-${now}-toggle-modal`,
      okID = `qa-${now}-toggle-confirm`,
      cancelID = `qa-${now}-toggle-cancel`,
      waitForSubmitResultToClose = false, //if this is set the dialog won't close unless ok onClick returns true
      okStyle,
      cancelStyle,
      customer,
    } = dialog;
    let cancelButtonClick = async () => {
      setProcessing(true);
      await cancelProcess();
      setProcessing(false);
      setModals(modals.filter((a, index) => index !== i));
    };
    let okButtonClick = async () => {
      setProcessing(true);
      const results = await okProcess();
      setProcessing(false);
      if (waitForSubmitResultToClose) {
        if (results) {
          setModals(modals.filter((a, index) => index !== i));
        }
      } else {
        setModals(modals.filter((a, index) => index !== i));
      }
    };

    return (
      <div key={i}>
        <ConnectedModal
          key={i}
          id="qa-generic-modal"
          className={modalClass}
          container={document.body}
          customer={customer || {}}
          title={title}
          fullScreen={fullScreen}
        >
          <div className="confirmation-section-wrapper" id={modalID}>
            <div className="confirmation-section-message">{contents}</div>

            <div className="confirmation-section-controls-no-pad" style={{ display: 'flex', width: '100%' }}>
              {cancelButtonText && (
                <Anchor
                  className="qa-generic-modal-cancel"
                  id={cancelID}
                  onClick={cancelButtonClick}
                  style={{ ...cancelStyle }}
                >
                  {cancelButtonText}
                </Anchor>
              )}
              {okButtonText && (
                <Button
                  id={okID}
                  disabled={processing || !okProcess}
                  className={`${okClass || 'confirm-cancel action-warning'} qa-modal-confirm`}
                  style={{ borderRadius: '40px', textTransform: 'none', ...okStyle }}
                  onClick={okButtonClick}
                >
                  {processing ? (
                    <div
                      id="modal-loading-spinner"
                      className="processing-icon load-spin"
                      style={{ padding: 'unset', paddingRight: '10px' }}
                    >
                      <Sun name="sun" className="sun-icon icon" />
                    </div>
                  ) : (
                    <div className={'action-contents'}>{okButtonText}</div>
                  )}
                </Button>
              )}
            </div>
          </div>
        </ConnectedModal>
      </div>
    );
  };
  return modals.map((dialog, i) => renderModal(dialog, i));
};

export default ModalStack;
